import React from 'react';
import Img from '../../assets/logoBeni.png'
import { useNavigate } from 'react-router-dom';

const Sobre = () => {
  const nav = useNavigate()
  return (
    <div className={'flex flex-col  p-4 sm:py-10 sm:px-20 justify-center align-middle items-center'}>
        <div className='flex max-w-[600px] flex-col border-1 border-yellow-700 rounded-md p-4 shadow-md text-[11pt]'>
        <img src={Img} width={100} height={100} className='m-4'/>
        <p className='px-4'> <span className='font-semibold'>A BeniÓticas é a referência em óculos de qualidade em Sarandi e Marialva,</span> oferecendo uma ampla seleção de armações e lentes das melhores grifes. Seja para óculos de grau ou de sol, nossa missão é garantir que você encontre o modelo perfeito, unindo estilo, conforto e precisão para todas as suas necessidades visuais. </p>
        <p className='px-4'>
            Em nosso <span className='font-semibold'>e-commerce</span>, trabalhamos com uma <span className='font-semibold'>seleta linha de armações</span>, pensadas para atender as necessidades do mercado com o melhor custo-benefício.
        </p>
        <hr/>
        <p className='px-4'>
            <span className='font-semibold'>Atuamos em todo o Brasil</span>, garantindo entrega rápida e segura para todos os nossos clientes. <span className='font-semibold'>Nossa missão é proporcionar aos consumidores armações de óculos de excelente qualidade</span>, que aliam design sofisticado, resistência e custo acessível, ajudando a criar o estilo perfeito para cada olhar.
        </p>
        <hr/>
        <div className='p-2 flex flex-row justify-between'>
          <p className='font-semibold underline cursor-pointer' onClick={()=>(nav('/termos'))}>Termos de uso e cookies</p>
          <p className='font-semibold underline cursor-pointer' onClick={()=>(nav('/politica-devolucao'))}>Política de devoluções</p>
        </div>
        </div>

    </div>
  );
};

export default Sobre;